import { IAppConfigDataModel } from '../../data-models/app-config.data-model';
import { IFormatterDataModel } from '../../data-models/formatter.data-model';
import { AppClientConfig, ClientConfigKey, FundWaterfallType } from '../../schemas/ClientConfig.schema';
import { ArrayFormattersConfig } from '../../util/formatters/ArrayFormattersConfig';
import { BooleanFormattersConfig } from '../../util/formatters/BooleanFormatters';
import { DateFormattersConfig } from '../../util/formatters/DateFormatters';
import { NumericFormattersConfig } from '../../util/formatters/NumericFormatters';
import { StringFormattersConfig } from '../../util/formatters/StringFormatters';
import { four_currencies } from './currencies.scenario';
import { test_fund0, test_fund1, test_fund3 } from './fund.scenario';
import { basic_metrics_config } from './metrics-config.scenario';
import { three_rounds } from './round.scenario';
import { two_sectors } from './sector.scenario';
import {
  buy_transaction_type,
  secondary_purchase_transaction_type,
  sell_transaction_type,
} from './transaction-types.scenario';
import { two_users } from './user.scenario';

export function basic_formatters(): IFormatterDataModel<unknown>[] {
  return [
    ...Object.values(NumericFormattersConfig),
    ...Object.values(DateFormattersConfig),
    ...Object.values(BooleanFormattersConfig),
    ...Object.values(ArrayFormattersConfig),
    ...Object.values(StringFormattersConfig),
  ];
}

export function createAllowFundWaterfallConfig(value: boolean): AppClientConfig {
  return [
    {
      id: Number(value),
      key: ClientConfigKey.AllowFundWaterfall,
      value: JSON.stringify(value),
      type: 'boolean',
    },
  ];
}

export function createFundWaterfallConfigs(type: FundWaterfallType, allowWaterfall = true): AppClientConfig {
  return [
    ...(createAllowFundWaterfallConfig(allowWaterfall) ?? []),
    {
      id: 2,
      key: ClientConfigKey.FundWaterfallType,
      value: type,
      type: 'string',
    },
  ];
}

export function basic_app_config(): IAppConfigDataModel {
  return {
    currencies: [],
    formatters: [],
    funds: [],
    metricsConfig: basic_metrics_config(),
    objectiveCategory: [],
    rounds: three_rounds(),
    sectors: [],
    teams: [],
    transactionTypes: [],
    users: [],
    updatedAt: new Date().toISOString(),
  };
}

export function app_config_with_generalinfo(): IAppConfigDataModel {
  return {
    ...basic_app_config(),
    clientConfig: createAllowFundWaterfallConfig(true),
    currencies: four_currencies(),
    users: two_users(),
    funds: [test_fund0(), test_fund3(), test_fund1()],
    sectors: two_sectors(),
    transactionTypes: [
      buy_transaction_type(),
      sell_transaction_type(),
      secondary_purchase_transaction_type(),
    ],
  };
}
